



document.addEventListener("DOMContentLoaded", function () {
    const peopleNav = document.querySelector('.team__list');

    if(peopleNav){
		
		// look at the URL and if there is a hash, open the tab
		const hash = window.location.hash;
		if (hash) {
			// find the link in the .team__list that matches the hash in the HREF attribute
			// and click it
			const link = jQuery('.team__list').find('a[href="' + hash + '"]');
			link.addClass('active');

			// scroll to the link
			const top = jQuery('.team').offset().top - 25;
			jQuery('body,html').stop().animate({scrollTop: top}, 500);
		}

    }
});
